import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import CalendarWithTabs from './CalendarWithTabs';
import { setVisibleMonths } from '../../Redux/store';
import usePredictedCalendar from '../../data/cycle-predictions/usePredictedCalendar';

function CalendarPage() {
  const dispatch = useDispatch();
  const startMonth = useSelector((s) => s.calendar.startMonth);
  const endMonth = useSelector((s) => s.calendar.endMonth);

  // Calculate end date from endMonth (YYYY-MM -> last day of month in YYYY-MM-DD)
  const endDate = useMemo(() => {
    if (!endMonth) return null;
    const [year, month] = endMonth.split('-').map(Number);
    const lastDay = new Date(year, month, 0).getDate();
    return `${year}-${String(month).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
  }, [endMonth]);

  // Get calendar data with predictions
  const { calendarData, loading } = usePredictedCalendar(endDate);

  const handleStartMonthChange = (newStart) => {
    dispatch(setVisibleMonths({ startMonth: newStart, endMonth }));
  };

  const handleEndMonthChange = (newEnd) => {
    dispatch(setVisibleMonths({ startMonth, endMonth: newEnd }));
  };

  return (
    <>
      <CalendarWithTabs
        calendarData={calendarData}
        startMonth={startMonth}
        endMonth={endMonth}
        onStartMonthChange={handleStartMonthChange}
        onEndMonthChange={handleEndMonthChange}
        isLoading={loading}
      />
    </>
  );
}

export default CalendarPage;
